import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const usePlatinumPlusGet = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();
  console.log("filters", filters);
  return useQuery(
    ["PlatinumPlusGet", filters],
    () => {
      const encodedEvents = filters.events.map(encodeURIComponent).join(";");
      return makeAuthedRequest(
        `v1/reporting/platinum-plus/year/${filters.year}/eventType/${filters.type}/event/${encodedEvents}`,
        {
          method: "GET",
        }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};
